<template>
  <v-app>
    <alert></alert>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

export default {
    metaInfo: {
        titleTemplate: '%s - ACISO GES Tool',
    },
  name: 'App',
  created() {
      console.log(process.env.NODE_ENV)
  }
};
</script>
